// 8 animal avatars hosted locally in /public/avatars/
export const PRESET_AVATARS = [
  { id: "howl", label: "Howl", src: "/avatars/howl.png" },
  { id: "fox", label: "Fox", src: "/avatars/fox.png" },
  { id: "red-panda", label: "Red Panda", src: "/avatars/red-panda.png" },
  { id: "hedgehog", label: "Hedgehog", src: "/avatars/hedgehog.png" },
  { id: "rabbit", label: "Rabbit", src: "/avatars/rabbit.png" },
  { id: "frog", label: "Frog", src: "/avatars/frog.png" },
  { id: "turtle", label: "Turtle", src: "/avatars/turtle.png" },
  { id: "snail", label: "Snail", src: "/avatars/snail.png" },
  { id: "dino", label: "Dino", src: "/avatars/dino.png" },
  { id: "koala", label: "Koala", src: "/avatars/koala.png" },
];

export const DEFAULT_AVATAR = "/avatars/howl.png";

// Avatar réservé à l'admin (n'apparaît dans les réglages que si user.is_admin)
export const ADMIN_AVATAR = { id: "admin", label: "Admin", src: "/avatars/admin.png" };

export function resolveAvatar(user) {
  if (!user) return DEFAULT_AVATAR;
  return user.custom_avatar || user.picture || DEFAULT_AVATAR;
}
